export default "__VITE_ASSET__CdaOgr_o__"